// extracted by mini-css-extract-plugin
export default {"displayGradient":"TvDisplay_displayGradient__EhKLc","Gradient":"TvDisplay_Gradient__l80Fc"};